import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class UserRolesRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.USER_ROLES);
    }

}



// WEBPACK FOOTER //
// ./src/app/users/ws/UserRolesRequest.js